import React from 'react';
import { RadarChart, Radar, PolarGrid, PolarAngleAxis, PolarRadiusAxis, ResponsiveContainer, Legend, Tooltip } from 'recharts';

const PerformanceRadarChart = ({ data }) => {
  const CustomTooltip = ({ active, payload }) => {
    if (active && payload && payload?.length) {
      return (
        <div className="bg-card border border-border rounded-lg shadow-lg p-3">
          <p className="text-sm font-medium text-foreground mb-2">{payload?.[0]?.payload?.category}</p>
          <p className="text-sm text-primary">
            Your Score: <span className="font-semibold">{payload?.[0]?.value?.toFixed(1)}%</span>
          </p>
          <p className="text-sm text-muted-foreground">
            Platform Avg: <span className="font-semibold">{payload?.[1]?.value?.toFixed(1)}%</span>
          </p>
        </div>
      );
    }
    return null;
  };

  if (!data || data?.length === 0) {
    return (
      <div className="h-80 flex items-center justify-center text-muted-foreground">
        <p>No performance data available</p>
      </div>
    );
  }

  return (
    <ResponsiveContainer width="100%" height={400}>
      <RadarChart data={data} margin={{ top: 20, right: 30, bottom: 20, left: 30 }}>
        <PolarGrid stroke="hsl(var(--border))" />
        <PolarAngleAxis 
          dataKey="category" 
          tick={{ fill: 'hsl(var(--foreground))', fontSize: 12 }}
        />
        <PolarRadiusAxis 
          angle={90} 
          domain={[0, 100]}
          tick={{ fill: 'hsl(var(--muted-foreground))', fontSize: 10 }}
        />
        <Radar 
          name="Your Performance" 
          dataKey="userScore" 
          stroke="hsl(var(--primary))" 
          fill="hsl(var(--primary))" 
          fillOpacity={0.6}
        />
        <Radar 
          name="Platform Average" 
          dataKey="platformAvg" 
          stroke="hsl(var(--muted-foreground))" 
          fill="hsl(var(--muted-foreground))" 
          fillOpacity={0.3}
        />
        <Tooltip content={<CustomTooltip />} />
        <Legend 
          wrapperStyle={{ fontSize: '14px' }}
          iconType="circle"
        />
      </RadarChart>
    </ResponsiveContainer>
  );
};

export default PerformanceRadarChart;